export const Endpoints = {
    users: '/tusers',
    categories: '/categories',
    forms: '/forms',
    reActivation: '/users/re-activation',
    lockedUsers: '/users/locked',
    applicationAuditTrail: '/applications/:id/audit-trail',
    applicationAuditTrailExport: '/applications/:id/audit-trail/export',
    applicationsExport: '/applications/export',
    userApplicationsExport: '/applications/user/:id/export',
    usersExport: '/users/export',
    userExport: '/users/:userId/export',
    userAuditLogs: '/user-audit-logs',
    userAuditLogsExport: '/user-audit-logs/export',
    userAuditLogsVerify: '/user-audit-logs/verify',
    userAuditTrail: '/users/:userId/audit-trail',
    userAuditTrailExport: '/users/:userId/audit-trail/export',
}